import I18n from 'I18n';
import styled from 'styled-components';
import { OBSIDIAN } from 'HubStyleTokens/colors';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIFormControl from 'UIComponents/form/UIFormControl';
import UIIconButton from 'UIComponents/button/UIIconButton';
import UIIcon from 'UIComponents/icon/UIIcon';
import UIInputStaticLabel from 'UIComponents/input/UIInputStaticLabel';
import UITextInput from 'UIComponents/input/UITextInput';
import UIFlex from 'UIComponents/layout/UIFlex';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const SmallerFontSizeUIInputStaticLabel = styled(UIInputStaticLabel).withConfig({
  displayName: "FilterDescriptionInput__SmallerFontSizeUIInputStaticLabel",
  componentId: "sc-1sgyk5n-0"
})(["span{font-size:12px;font-weight:500;}"]);
const WithStaticLabel = ({
  children,
  labelDisplayed,
  position,
  text
}) => labelDisplayed ? /*#__PURE__*/_jsx(SmallerFontSizeUIInputStaticLabel, {
  position: position,
  text: text,
  children: children
}) : children;
const FilterDescriptionInput = ({
  autoFocus = false,
  disabled = false,
  hasError = false,
  labelDisplayed = false,
  onChange,
  onRemove,
  readOnly = false,
  removeDisplayed = false,
  value
}) => {
  return /*#__PURE__*/_jsx(UIFormControl, {
    className: "m-top-2",
    children: /*#__PURE__*/_jsx(WithStaticLabel, {
      labelDisplayed: labelDisplayed,
      position: "start",
      text: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "automation-ui-enrollment.aiAssistantFilterDescription.filterForm.labels.and"
      }),
      children: /*#__PURE__*/_jsxs(UIFlex, {
        align: "center",
        justify: "end",
        children: [/*#__PURE__*/_jsx(UITextInput, {
          use: "on-dark",
          "data-test-id": "ai-assistant-trigger-description-input",
          autoFocus: autoFocus,
          disabled: disabled,
          error: hasError,
          onChange: ({
            target: {
              value: inputValue
            }
          }) => onChange(inputValue),
          name: "trigger-description",
          placeholder: I18n.text('automation-ui-enrollment.aiAssistantFilterDescription.filterForm.inputPlaceholder'),
          readOnly: readOnly,
          value: value
        }), removeDisplayed && /*#__PURE__*/_jsx(UIIconButton, {
          onClick: onRemove,
          title: "Remove",
          use: "link",
          children: /*#__PURE__*/_jsx(UIIcon, {
            className: "m-x-2",
            color: OBSIDIAN,
            name: "delete",
            size: "xxs"
          })
        })]
      })
    })
  });
};
export default FilterDescriptionInput;